/**
 * Real product cover image with editorial frame.
 * Used in product cards when product.images is available.
 * Accepts an image object {url, alt} or a plain url string.
 */
import { imgUrl, imgAlt } from "@/lib/productImages";

export default function ProductCover({ image, alt = "", locked = false }) {
  const src = imgUrl(image);
  const finalAlt = imgAlt(image, alt);
  if (!src) return null;
  return (
    <div
      data-testid="product-cover"
      className={`relative aspect-[4/5] w-full overflow-hidden ${
        locked ? "file-card-locked" : "bg-[#0a0316]"
      }`}
    >
      <img
        src={src}
        alt={finalAlt}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]"
        loading="lazy"
        draggable={false}
      />

      {/* Bottom-left brand mark */}
      <div className="absolute bottom-4 left-5 flex items-center gap-2 font-mono text-[10px] tracking-[0.24em] uppercase text-white/85 drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)]">
        <span className="w-1 h-1 bg-[#ff1493] rounded-full" />
        FEMBOT NEX
      </div>
    </div>
  );
}
